import { createSelector } from 'reselect'

import { RootState } from 'redux/store'
import { SearchType } from 'types/Search'

const selectSearchType = createSelector(
  (state: RootState) => state.search.searchType,
  (searchType: SearchType) => searchType
)

export default selectSearchType
